<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import {setFocusTo, copyObject, copyObjectData} from "../lib/lib";
    import Notifier from "../stores/notifier";

    export let vehicleTypeId = null;
    export let closeCallback;

    let vehicleType = null;

    const initialize = () => {
        if (vehicleTypeId == 0) {
            vehicleType = {
                id: 0,
                type: '',
                name: '',
                description: '',
                info: '',
                min_pax: 1,
                max_pax: 4,
                is_active: 1,
            }
        } else {
            let item = $app.vehicle_types.find(x => x.id == vehicleTypeId);
            if (item) {
                vehicleType = copyObject(item);
            }
        }
        setFocusTo('typeName');
    }

    const save = () => {
        const onSuccess = result => {
            let item = $app.vehicle_types.find(x => x.id == result.id);
            if (!item) {
                $app.vehicle_types = [result, ...$app.vehicle_types];
            } else {
                copyObjectData(result, item);
                $app.vehicle_types = $app.vehicle_types;
            }
            vehicleType = null;
            Notifier.showMessage("Vehicle type updated");
            close();
        }

        const onFailure = err => {
        };

        vehicleType.type = vehicleType.type.trim();
        vehicleType.name = vehicleType.name.trim();

        if (!vehicleType.type) {
            Notifier.showError("Enter the type for vehicle!");
            setFocusTo("typeType");
            return;
        }

        if (!vehicleType.name) {
            Notifier.showError("Enter a name for vehicle type!");
            setFocusTo("typeName");
            return;
        }

        let action = vehicleTypeId == 0 ? 'create' : 'edit';
        R.handle(R.vehicleType[action], vehicleType, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        closeCallback();
    }

    initialize();
</script>

{#if vehicleType}
    <Modal title="Vehicle type" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Type</label>
                <input type="text" class="form-control" id="typeType" bind:value="{ vehicleType.type }">
            </div>
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="typeName" bind:value="{ vehicleType.name }">
            </div>
            <div class="form-group">
                <label>Description</label>
                <input type="text" class="form-control" bind:value="{ vehicleType.description }">
            </div>
            <div class="form-group">
                <label>Reservation info</label>
                <input type="text" class="form-control" bind:value="{ vehicleType.info }">
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Min max</label>
                        <input type="number" class="form-control" bind:value="{ vehicleType.min_pax }">
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Max max</label>
                        <input type="number" class="form-control" bind:value="{ vehicleType.max_pax }">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <Checkbox label="Active vehicle type" bind:checked={ vehicleType.is_active }/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ close }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}